var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManChillingOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 635 789"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#man-chilling-out_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m507 84.955 2.5 8 34.5-12.5-9-27z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "m513.5 111.195-6.5-17.5 38.5-16 5.5 16 31.5-13.5 13.742 34.354c5.845 14.613-4.237 34.253-18.742 28.146-9.5-4-64-31.5-64-31.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M224.654 142.5a4.89 4.89 0 0 1-4.42-4.45v0a3.32 3.32 0 0 1 1.695-3.184l5.307-2.951c2.725-1.514 5.783-2.314 8.898-2.426 3.31-.119 7.799-.354 11.613-.812v0c10.12-1.215 20.489-.761 29.892 3.172l31.889 13.34 18.279 8.355-14.483 11.228-23.379-4.14a76 76 0 0 1-24.902-9.107l-2.965-1.721s-5.84-3.821-11.134-4.613c-3.959-.593-18.966-2.012-26.29-2.691Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M451.071 210.257a7 7 0 0 1-8.242.684l-116.071-71.037c-3.89-2.381-8.98-1.033-11.181 2.961l-13.922 25.253a7 7 0 0 0 2.212 9.18l136.12 91.942a28 28 0 0 0 33.094-1.283l99.631-79.186-10.812-74.694z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m373.668 641.211 20.603 50.995-38.923 21.118-18.482-55.087zM141.423 610.68l-30.755 45.597-39.274-20.46 35.335-46.127zM255.845 420.315l-8.827 29.491-43.679-4.829 6.638-37.786z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M512.878 106.77 508 86.955Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M512.878 106.77 508 86.955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m535 53.455 17.019 47.579Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m535 53.455 17.019 47.579"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m521.5 339.195 11.317 13.376c15.744 18.607 3.903 47.227-20.385 49.272l-225.93 19.024-120.644 188.691c-11.258 17.608-34.854 22.404-52.092 10.588l-12.197-8.36c-15.993-10.962-20.81-32.41-11.044-49.159l112.152-192.311a74 74 0 0 1 65.554-36.703z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M584.047 324.169v63.978c0 16.577-13.445 30.012-30.022 30l-242.483-.177 79.748 200.471c6.31 15.861.949 33.981-12.975 43.856l-9.527 6.757c-19.186 13.607-46.032 6.093-55.367-15.497l-99.905-231.084c-21.335-49.347 15.409-104.257 69.164-103.356z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M577.406 127.581c-.825-24.551-25.132-41.328-48.379-33.392v0a66.72 66.72 0 0 0-34.269 50.826l-18.217 156.488L465 322.455l119 1.5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "man-chilling-out_svg__b",
  width: 123,
  height: 234,
  x: 463,
  y: 91,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M577.406 127.581c-.825-24.551-25.132-41.328-48.379-33.392v0a66.72 66.72 0 0 0-34.269 50.826l-18.217 156.488L465 322.455l119 1.5z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#man-chilling-out_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "m513 126.195 30.5 126.5 7 41 56.5 11.5-39-185.74z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m535.796 55.914-4.82-16.807c-6.021-17.032-24.148-21.607-39.257-12.715-16.398 9.65-16.015 24.014-12.842 42.999 3.172 18.984 9.427 25.372 27.026 18.966 5.605-2.04 13.342-8.94 13.342-8.94",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m535.796 55.914-4.82-16.807c-6.021-17.032-24.148-21.607-39.257-12.715-16.398 9.65-16.015 24.014-12.842 42.999 3.172 18.984 9.427 25.372 27.026 18.966 5.605-2.04 13.342-8.94 13.342-8.94"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M528.172 64.706c2.758-3.147 3.72-7.843 2.109-12.269-2.294-6.3-8.932-9.67-14.828-7.524a10.8 10.8 0 0 0-5.093 3.883",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M528.172 64.706c2.758-3.147 3.72-7.843 2.109-12.269-2.294-6.3-8.932-9.67-14.828-7.524a10.8 10.8 0 0 0-5.093 3.883"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "m510.021 52.418-3.872-10.741-27.798 1.691s.243-2.124 1.398-4.447c6.365-12.792 13.609-14.306 17.144-15.044q.29-.06.545-.116c8.071-1.775 14.136-1.075 14.136-1.075s.968.904 9.804 3.372 15.016 27.98 15.016 27.98l-5.788 1.606-.723.41c-.054-1-.254-2.01-.615-3.001-1.961-5.388-7.915-8.167-13.3-6.207a10.34 10.34 0 0 0-5.947 5.572",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M328.599 311.777a4.886 4.886 0 0 1-5.578-2.867v0a3.32 3.32 0 0 1 .628-3.551l4.136-4.446c2.123-2.283 4.784-3.988 7.712-5.058 3.111-1.136 7.308-2.746 10.793-4.36v0c9.25-4.283 19.251-7.056 29.41-6.221l34.451 2.833 19.966 2.297-10.305 15.155-23.513 3.287a76 76 0 0 1-26.498-.966l-3.352-.721s-6.735-1.83-12.015-.947c-3.948.66-18.659 3.947-25.835 5.565Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m513 125.955 44.5 109.74-149.596 39.892a8 8 0 0 0-5.62 9.963l10.216 35.145 187.765-32.432c15.238-2.632 25.458-17.118 22.826-32.357a28 28 0 0 0-.997-3.992L575.5 116.955",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m513 125.955 44.5 109.74-149.596 39.892a8 8 0 0 0-5.62 9.963l10.216 35.145 187.765-32.432c15.238-2.632 25.458-17.118 22.826-32.357a28 28 0 0 0-.997-3.992L575.5 116.955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m281.949 191.553-7.26.892 15.596 127.159 2.75-.338 125.925 2.198.122-6.999-122.321-2.135z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m274.689 192.445-.122-.993-.992.122.122.993zm7.26-.892.992-.122-.122-.993-.992.122zm8.336 128.051-.993.121.122.993.993-.122zm2.75-.338.018-1-.07-.001-.07.008zm125.925 2.198-.018.999 1 .018.018-1zm.122-6.999 1 .017.017-1-1-.017zm-122.321-2.135-.992.121.106.863.869.015zm-21.95-118.892 7.26-.893-.244-1.985-7.26.892zm16.467 126.044-15.596-127.159-1.985.244 15.595 127.158zm1.635-1.209-2.75.338.244 1.985 2.75-.338zm126.064 2.191-125.924-2.198-.035 1.999 125.924 2.198zm-.895-6.017-.122 6.999 2 .035.122-6.999zm-121.338-1.118 122.32 2.136.035-2-122.32-2.135zm-15.788-121.655 14.813 120.777 1.985-.243-14.813-120.777z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M123.506 656.774c1.97-5.21-.665-11.121-5.612-13.681a139 139 0 0 1-15.003-9.041c-13.627-9.403-14.648-17.391-14.648-17.391s-14.989-2.541-19.536-2.345c-3.28.141-5.944.486-8.322.793-5.022.65-8.762 1.134-14.3-.818-38.046-13.411-40.923-5.078-42.56-.333q-.032.09-.062.178c-1.633 4.709 6.597 12.908 6.597 12.908l46.366 26.769 24.448 14.115 31.411 14.976 4.18-7.507zm277.272 30.347c-2.574-3.637-7.666-4.531-11.542-2.33-4.188 2.377-10.178 5.439-17.653 8.368-15.417 6.039-22.609 2.418-22.609 2.418s-10.488 11.006-12.869 14.885c-1.717 2.798-2.921 5.2-3.996 7.343-2.269 4.527-3.96 7.898-8.674 11.397-32.394 24.042-27.094 31.087-24.076 35.099l.113.15c2.991 3.987 14.39 1.749 14.39 1.749l48.121-23.47 25.372-12.375 29.981-17.668-3.887-7.662z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "man-chilling-out_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h635v789H0z"
})))));
export default SvgManChillingOut;